import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  filter,
  map,
  withLatestFrom
} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityPaisesLoadFailure,
  entityPaisesLoadRequest,
  entityPaisesLoadSuccess
} from './entity-paises.actions';
import { selectAllPaises } from './entity-paises.selectors';
import { PaisesService } from '@rpe/registro-personas-empresas-lib/src/projects';

@Injectable()
export class PaisesEffects {
  // load
  loadRequestPaises = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPaisesLoadRequest),
      // Don't load if we've already loaded.
      withLatestFrom(this.store.select(selectAllPaises)),
      filter(([_, loaded]) => loaded.length == 0),
      exhaustMap(() =>
        this.paisesService.getPaises().pipe(
          map((items) => entityPaisesLoadSuccess({ items })),
          catchError((error) => of(entityPaisesLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private paisesService: PaisesService
  ) {
    this.paisesService.url = environment.apiUrl;
  }
}
